<template>
  <div class="w-full h-full pt-5 px-3" v-if="show">
    <template>
      <template>
        <div class="flex flex-row justify-start items-center gap-4">
          <div class="flex gap-5">
            <div class="text-darkPurple flex items-center gap-2" @click="navigateBack()">
              <span>
                <Icon icon-name="back_arrow" class="cursor-pointer" size="m" />
              </span> Back
            </div>
            <div class="opacity-50 pipe text-romanSilver">|</div>
          </div>
          <h1 class="text-xl font-extrabold">Employees</h1>
          <Breadcrumb :items="breadcrumbs" />
        </div>
      </template>
      <template>
        <div class="flex flex-col mt-5 gap-10">
          <div class="flex flex-col font-bold text-18 text-darkPurple border-b border-borderGrey py-2">
            <div class="">Contract Renewal Checklist</div>
          </div>
          <div class="shadow w-full grid grid-cols-2 justify-between">
            <div class="col-span-1 flex gap-5 w-full">
              <div class="w-100 h-28 rounded-md overflow-hidden flex-shrink-0" v-if="employeeInfo.photo">
                <img :src="employeeInfo.photo" alt="profile" class="h-full w-full object-cover">
              </div>
              <div v-else class="w-100 h-28 rounded-md border flex justify-center items-center flex-shrink-0">
                <span class="text-center font-bold text-lg text-blueCrayola">
                  {{ $getInitials(`${employeeInfo.fname || ''} ${employeeInfo.lname || ''}`) || '-' }}
                </span>
              </div>
              <div class="flex flex-col h-full justify-between w-full">
                <div class="flex items-center mb-5 gap-5">
                  <div class="flex items-center text-darkPurple font-bold text-18">{{ employeeFullName }}</div>
                  <div class="flex items-center promotion-status text-flame text-14">Renewal in Progress</div>
                </div>
                <div class="flex w-full justify-between gap-5" v-for="field in employeeFields" :key="field.label">
                  <div class="text-14 text-romanSilver uppercase font-extrabold text-left w-full">{{ field.label }}:</div>
                  <div class="text-14 text-darkPurple font-bold text-left w-full">{{ field.value }}</div>
                </div>
              </div>
            </div>

            <div class="col-span-1 flex justify-between">
              <div class=""></div>
              <div class="btn-cancel text-flame cursor-pointer" @click="navigateBack()">Cancel Renewal</div>
            </div>
          </div>
          <div class="w-80 flex justify-center tiny bg-borderGrey items-center m-auto"></div>
          <div class="shadow w-full grid grid-cols-8 justify-between">
            <div class="col-span-2 flex flex-col border-r border-borderGrey px-5">
              <div
                v-for="(stepName, index) in steps"
                :key="index"
                :class="{
                  'nav-item capitalize': true,
                  'active': step === stepName,
                  'text-darkPurple': step === stepName,
                  'text-romanSilver': step !== stepName
                }"
              >
                {{ stepName === 'basic-info' ? 'Basic Info' : stepName }}
              </div>
            </div>
            <div class="col-span-6 px-5">

              <div class="w-full flex flex-col gap-5" v-if="step === 'intro'">
                <div class="intro-desc text-mediumSeaGreen border border-mediumSeaGreen flex gap-2 items-center">
                  <Icon icon-name="info_icon_green" size="s" />
                  You have initiated the process of renewing {{ employeeFullName }}'s contract. Click on Next to proceed.
                </div>
                <div class="flex gap-5 items-center justify-end cursor-pointer">
                  <div class="count flex items-center justify-center font-extrabold text-lg p-1">1</div>
                  <div class="flex flex-col justify-center" @click="navigate(steps[steps.indexOf(step) + 1])">
                    <div class="text-xs text-flame">2/3 Next</div>
                    <div class="text-xs text-darkPurple font-extrabold uppercase">Basic Info</div>
                  </div>
                  <div class="" @click="navigate(steps[steps.indexOf(step) + 1])">
                    <Icon icon-name="nextArrow" size="xs" />
                  </div>
                </div>
              </div>

              <div class="flex flex-col w-full gap-5" v-if="step === 'basic-info'">
                <div class="w-full grid grid-cols-3 justify-start items-start gap-4">
                  <div class="col-span-1 flex flex-col justify-start gap-2">
                    <p class="text-jet text-sm mr-5">Engagement Date</p>
                    <div class="date-flex">
                      <datepicker
                        placeholder="--Engagement Date--"
                        input-class="date-input date-input_disabled cursor-not-allowed"
                        style="width:100%;"
                        disabled
                        v-model="employeeInfo.engagementDate"
                      />
                    </div>
                  </div>
                  <div class="col-span-1 flex flex-col justify-start gap-2">
                    <p class="text-jet text-sm mr-5">Contract End Date</p>
                    <div class="date-flex">
                      <datepicker
                        placeholder="--Contract End Date--"
                        input-class="date-input date-input_disabled cursor-not-allowed"
                        style="width:100%;"
                        disabled
                        v-model="employeeInfo.contractEndDate"
                      />
                    </div>
                  </div>
                  <div class="col-span-1 flex flex-col justify-start gap-2">
                    <p class="text-jet text-sm mr-5">New Contract End Date</p>
                    <validation-provider class="w-full" name="New contract end date" :rules="{required: true}" v-slot="{ errors }">
                      <div :class="errors[0] ? 'border border-desire rounded-md' : 'date-flex'">
                        <datepicker
                          placeholder="--Select Date--"
                          input-class="date-input"
                          style="width:100%;"
                          :rules="['required']"
                          v-model="payload.newContractEndDate"
                        />
                      </div>
                      <small class="text-desire">{{ errors[0] }}</small>
                    </validation-provider>
                  </div>
                </div>
                <div class="p-2 border border-borderGrey comment">
                  <div class="text-romanSilver text-sm mb-2">Additional Note <span class="text-desire">*</span></div>
                  <validation-provider class="w-full" name="Additional note" :rules="{ required: true }" v-slot="{ errors }">
                    <textarea
                      class="w-full text-jet text-sm outline-none resize-none"
                      :class="{ 'border border-desire rounded-md': errors[0] }"
                      rows="4"
                      placeholder="Enter additional note"
                      v-model="payload.note"
                    />
                    <small class="text-desire">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="flex flex-col gap-3">
                  <p class="text-jet text-sm">Upload Attachment</p>
                  <div
                    ref="dropContainer"
                    @dragover.prevent="dragOver"
                    @dragleave.prevent="dragLeave"
                    @drop.prevent="handleDropFile"
                    class="upload-zone w-full bg-white flex flex-col justify-center items-center gap-3 py-8 rounded-md"
                  >
                    <div class="upload-icon-wrap flex items-center justify-center">
                      <img src="@/assets/icons/cloud-upload.svg" alt="upload" class="cloud-upload-icon" />
                    </div>
                    <p class="text-sm text-darkPurple">
                      Drag and drop files here, or
                      <span class="text-flame font-semibold cursor-pointer underline" @click="triggerInputFile">browse</span>
                    </p>
                    <p class="text-xs text-romanSilver">
                      Supported formats: PDF, DOC, DOCX, JPG, PNG • Max file size: 5MB
                    </p>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      @change="handleInputFile"
                      ref="fileInput"
                      hidden
                    />
                  </div>
                  <div
                    v-if="attachmentFile"
                    class="flex justify-between items-center gap-2 p-3 border border-borderGrey rounded-md cursor-pointer hover:bg-gray-50"
                    @click="openPreview"
                  >
                    <div class="flex items-center gap-2 min-w-0">
                      <Icon
                        v-if="isPdfPreview"
                        icon-name="icon-pdf"
                        size="m"
                        class-name="flex-shrink-0"
                      />
                      <Icon
                        v-else
                        :icon-name="attachmentIcon"
                        size="xs"
                        class-name="flex-shrink-0"
                      />
                      <div class="flex flex-col min-w-0">
                        <span class="text-sm text-blueCrayola font-semibold truncate">{{ attachmentFile.name }}</span>
                        <span class="text-xs text-blueCrayola">
                          {{ attachmentFile.name.replace(/\.[^/.]+$/, "").toLowerCase() }} • {{ formatFileSize(attachmentFile.size) }}
                        </span>
                      </div>
                    </div>
                    <Icon
                      icon-name="icon-close"
                      size="xs"
                      class-name="text-romanSilver cursor-pointer flex-shrink-0"
                      @click.native.stop="removeAttachment"
                    />
                  </div>
                </div>
                <div class="flex justify-end gap-5">
                  <div class="flex gap-5 items-center justify-end cursor-pointer" @click="navigate(steps[steps.indexOf(step) - 1])">
                    <div class="">
                      <Icon icon-name="prevArrow" size="xs" />
                    </div>
                    <div class="flex flex-col justify-center">
                      <div class="text-xs text-romanSilver">1/3 Previous</div>
                      <div class="text-xs text-darkPurple font-extrabold uppercase">Intro</div>
                    </div>
                  </div>
                  <div class="count flex items-center justify-center font-extrabold text-lg p-1">2</div>
                  <div class="flex gap-5 items-center justify-end cursor-pointer" @click="navigate(steps[steps.indexOf(step) + 1])">
                    <div class="flex flex-col justify-center">
                      <div class="text-xs text-flame">3/3 Next</div>
                      <div class="text-xs text-darkPurple font-extrabold uppercase">Confirm</div>
                    </div>
                    <div class="">
                      <Icon icon-name="nextArrow" size="xs" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-col w-full gap-10" v-if="step === 'confirm'">
                <div class="intro-desc text-mediumSeaGreen border border-mediumSeaGreen flex gap-2 items-center">
                  <Icon icon-name="info_icon_green" size="s" />
                  Congratulations! You have completed {{ displayValue(employeeInfo.fname) }}'s contract renewal process. Click confirm to finish. This action will take effect as required when approved.
                </div>
                <div class="w-full flex justify-between">
                  <div class="flex gap-5">
                    <div class="flex gap-5 items-center justify-end cursor-pointer" @click="navigate(steps[steps.indexOf(step) - 1])">
                      <div class="">
                        <Icon icon-name="prevArrow" size="xs" />
                      </div>
                      <div class="flex flex-col justify-center">
                        <div class="text-xs text-romanSilver">2/3 Previous</div>
                        <div class="text-xs text-darkPurple font-extrabold uppercase">Basic Info</div>
                      </div>
                    </div>
                    <div class="count flex items-center justify-center font-extrabold text-lg p-1">3</div>
                  </div>
                  <div class="flex gap-5">
                    <div class="radius text-dynamicBackBtn border border-solid border-dynamicBackBtn" @click="navigateBack()">
                      <button class="font-semibold rounded-md text-center radius buttonFocus btn"> Cancel </button>
                    </div>
                    <div class="radius bg-flame text-white" @click="onSubmit()">
                      <button class="font-semibold rounded-md text-center radius buttonFocus btn" :disabled="isLoading"> Confirm </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>

    <Modal v-if="showPreview">
      <Card class="bg-white p-5 flex flex-col gap-4 preview-modal">
        <div class="flex justify-between items-center gap-3">
          <p class="text-darkPurple font-bold truncate">{{ attachmentFile && attachmentFile.name }}</p>
          <Icon
            icon-name="icon-close"
            size="xs"
            class-name="text-romanSilver cursor-pointer"
            @click.native="closePreview"
          />
        </div>
        <div class="preview-body w-full flex justify-center items-center overflow-auto">
          <img
            v-if="isImagePreview"
            :src="previewUrl"
            alt="attachment preview"
            class="max-w-full max-h-full object-contain rounded"
          />
          <iframe
            v-else-if="isPdfPreview"
            :src="previewUrl"
            class="w-full h-full border-0 rounded"
            title="PDF preview"
          />
          <div v-else class="flex flex-col items-center gap-3 py-10">
            <Icon icon-name="doc" size="l" class-name="text-blueCrayola" />
            <p class="text-sm text-jet text-center">
              Preview is not available for this file type. You can still attach and submit it.
            </p>
          </div>
        </div>
      </Card>
    </Modal>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import Datepicker from "vuejs-datepicker";
import { format } from "date-fns";
import axios from "axios";
import Modal from "@/components/Modal";
import Card from "@/components/Card";

const ACCEPTED_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
const MAX_FILE_SIZE = 5 * 1024 * 1024;

export default {
  components: {
    ValidationProvider,
    Breadcrumb,
    Datepicker,
    Modal,
    Card,
  },
  data() {
    return {
      step: "intro",
      steps: ["intro", "basic-info", "confirm"],
      payload: {
        newContractEndDate: "",
        note: "",
      },
      attachmentFile: null,
      previewUrl: "",
      showPreview: false,
      isLoading: false,
      employeeInfo: {},
      show: false,
      breadcrumbs: [
        { disabled: false, text: "Employee", href: "", id: "Employee" },
        { disabled: false, text: "Contract Employees", href: "ContractEmployees", id: "ContractEmployees" },
      ],
    };
  },
  computed: {
    employeeFullName() {
      const name = [this.employeeInfo.fname, this.employeeInfo.lname]
        .filter((part) => part && String(part).trim())
        .join(" ");
      return name || "-";
    },
    employeeFields() {
      return [
        { label: "Organisational Unit", value: this.displayValue(this.employeeInfo.function) },
        { label: "Position", value: this.displayValue(this.employeeInfo.designation) },
        { label: "Job Level", value: this.displayValue(this.employeeInfo.level) },
        { label: "Employment Type", value: this.displayValue(this.employeeInfo.employmentType) },
      ];
    },
    fileExtension() {
      if (!this.attachmentFile?.name) return "";
      return this.attachmentFile.name.split(".").pop().toLowerCase();
    },
    isImagePreview() {
      return ["jpg", "jpeg", "png"].includes(this.fileExtension);
    },
    isPdfPreview() {
      return this.fileExtension === "pdf";
    },
    attachmentIcon() {
      if (this.isPdfPreview) return "pdf";
      if (this.isImagePreview) return "jpg";
      return "doc";
    },
  },
  methods: {
    displayValue(value) {
      if (value === null || value === undefined || String(value).trim() === "") return "-";
      return value;
    },
    navigate(step) {
      if (!step) return;
      if (this.steps.indexOf(step) < this.steps.indexOf(this.step)) {
        this.step = step;
      } else {
        const isValid = this.validateInputs(this.step);
        if (isValid) {
          this.step = step;
        }
      }
    },
    navigateBack() {
      this.$router.push({ name: "ContractEmployees" });
    },
    validateInputs(step) {
      if (step === "basic-info") {
        if (!this.payload.newContractEndDate || !String(this.payload.note || "").trim()) {
          this.$toasted.error("Enter required fields now!", { duration: 3000 });
          return false;
        }
      }
      return true;
    },
    triggerInputFile() {
      this.$refs.fileInput.click();
    },
    dragOver(e) {
      e.currentTarget.classList.add("is-dragging");
    },
    dragLeave(e) {
      e.currentTarget.classList.remove("is-dragging");
    },
    handleDropFile(e) {
      e.currentTarget.classList.remove("is-dragging");
      const files = e.dataTransfer.files;
      if (files.length > 0) this.setAttachment(files[0]);
    },
    handleInputFile(event) {
      const files = event.target.files;
      if (files.length > 0) this.setAttachment(files[0]);
      event.target.value = "";
    },
    setAttachment(file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (!ACCEPTED_EXTENSIONS.includes(extension)) {
        this.$toasted.error("Unsupported file type. Use PDF, DOC, DOCX, JPG or PNG.", { duration: 5000 });
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        this.$toasted.error("File size must not exceed 5MB.", { duration: 5000 });
        return;
      }
      this.revokePreviewUrl();
      this.attachmentFile = file;
      this.previewUrl = URL.createObjectURL(file);
    },
    formatFileSize(size) {
      if (!size) return "-";
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / (1024 * 1024)).toFixed(1)} MB`;
    },
    openPreview() {
      if (!this.attachmentFile || !this.previewUrl) return;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
    },
    revokePreviewUrl() {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = "";
      }
    },
    removeAttachment() {
      this.closePreview();
      this.revokePreviewUrl();
      this.attachmentFile = null;
    },
    async uploadAttachment() {
      if (!this.attachmentFile) return null;
      const file = this.attachmentFile;
      const { data } = await this.$_uploadLargerFile({
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
      });
      await axios.put(data.uploadUrl, file, {
        headers: { "Content-Type": file.type },
      });
      return data.fileUrl;
    },
    async onSubmit() {
      if (!this.validateInputs("basic-info")) {
        this.step = "basic-info";
        return;
      }
      this.isLoading = true;
      try {
        const fileUrl = await this.uploadAttachment();
        const payload = {
          orgId: this.$orgId,
          userId: this.employeeInfo.userId,
          newContractEndDate: format(new Date(this.payload.newContractEndDate), "yyyy-MM-dd"),
          initiatedBy: this.$AuthUser.id,
          note: this.payload.note.trim(),
          ...(fileUrl && { fileUrl }),
        };
        const { data } = await this.$_extendEmployeeContract(payload);
        this.$toasted.success(data.message || "Contract extended successfully", { duration: 5000 });
        this.navigateBack();
      } catch (error) {
        this.$toasted.error(error?.message || error, { duration: 5000 });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    if (this.$route.params.employeeInfo) {
      this.employeeInfo = this.$route.params.employeeInfo;
      this.show = true;
    } else {
      this.$router.push({ name: "ContractEmployees" });
    }
  },
  beforeDestroy() {
    this.revokePreviewUrl();
  },
};
</script>

<style scoped>
.pipe {
  font-size: 24px;
}
.shadow {
  box-shadow: 0px 1px 3px 0px #0807081A;
  box-shadow: 0px 1px 2px 0px #2D31420F;
  padding: 12px 16px 12px 16px;
  border-radius: 5px;
}
.count {
  box-shadow: 0px 1px 3px 0px #0807081A;
  box-shadow: 0px 1px 2px 0px #2D31420F;
  border-radius: 5px;
  height: 40px;
  width: 40px;
}
.btn-cancel {
  padding: 8px 12px 8px 12px;
  border-radius: 5px;
  border: 1px solid #F15A29;
  height: fit-content;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: fit-content;
}
.w-100 {
  width: 100px;
}
.promotion-status {
  padding: 4px 8px 4px 8px;
  background-color: #E993231F;
  color: #E99323;
  border: 1px solid #E99323;
  border-radius: 5px;
}
.w-80 {
  width: 80%;
}
.tiny {
  height: 1px;
  opacity: 0.4;
}
.nav-item {
  padding: 5px 12px;
  font-weight: 600;
}
.nav-item.active {
  border-right: 4px solid #F15A29;
}
.intro-desc {
  padding: 12px 16px 12px 16px;
  background-color: #13B56A0F;
  font-size: 14px;
  line-height: 18px;
  border: 1px solid #13B56A;
  border-radius: 5px
}
.comment {
  border-radius: 4px;
}
.btn {
  padding: 12px 24px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.date-input_disabled {
  background-color: #EEEEEE;
}
.upload-zone {
  border: 1px dashed #C5C9D0;
}
.upload-zone.is-dragging {
  background-color: #F8F8F8;
  border-color: #F15A29;
}
.upload-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 9999px;
  background: rgba(241, 90, 41, 0.1);
}
.cloud-upload-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.preview-modal {
  width: min(720px, 92vw);
  max-height: 85vh;
}
.preview-body {
  min-height: 280px;
  max-height: 70vh;
}
.h-28 {
  height: 7rem;
}
</style>
